import { render } from "./NotificationsVue.vue?vue&type=template&id=22c7d85f"
import script from "./NotificationsVue.vue?vue&type=script&lang=js"
export * from "./NotificationsVue.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\WEB-SITE-DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__